import { getFacilitiesTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import "@/components/HowItWorks.scss";
import { Table } from "antd";
import { Link } from "react-router-dom";

export function FacilitiesHowItWorks() {
  const dataSource = [
    {
      id: 180,
      facility_name: "Sapphire Textile Mills Limited",
      is_archived: false,
      address: "Block A Gulberg 2, Lahore, Punjab, Pakistan",
      category: "Supplier",
    },
    {
      id: 181,
      facility_name: "Unilabel Portugal",
      is_archived: false,
      address: "R. Comendador Alberto de Magalhães e Sousa, Vila nova de sande, Portugal",
      category: "Supplier",
    },
    {
      id: 182,
      facility_name: "Warehouse Amsterdam",
      is_archived: false,
      address: "Casablancaweg 14, 1047 HP Amsterdam, Nederland",
      category: "Warehouse",
    },
    {
      id: 183,
      facility_name: "C&C Metal Products Corp.",
      is_archived: false,
      address: "456 Nordhoff Pl, Englewood, NJ 07631, Verenigde Staten",
      category: "Supplier",
    },
  ];

  return (
    <div className="HowItWorks">
      <div className="container">
        <div className="text-container">
          <h1>Facilities</h1>
          <p>
            All facilities you operate from. i.e. supplier's factories, processing sites,
            warehouses, stores or offices.
          </p>
          <h2>Uploading in 4 simple steps</h2>
          <ol>
            <li>
              First, upload your <Link to="/orders/purchase_orders">purchase</Link> &{" "}
              <Link to="/orders/sales_orders">sales</Link> orders. Root will automatically identify
              all unique facilities from this data. After that, you can easily add or remove
              facilities as necessary in this chapter.
            </li>
            <li>
              Download{" "}
              <FileDownloader
                fileUrlFn={getFacilitiesTemplate}
                type="text"
                fileOutputName="template-facilities.xlsx"
                buttonText="the template"
              />
              .
            </li>
            <li>
              Fill in the tile or click "Add manually" at the top right corner to add facilities one
              by one.
            </li>
            <li>Upload your file and click save.</li>
          </ol>
          <h2>Example template</h2>
        </div>
        <div className="data-container">
          <Table
            dataSource={dataSource}
            pagination={false}
            bordered={false}
          >
            <Table.Column
              title="Facility name"
              dataIndex="facility_name"
            />
            <Table.Column
              title="Address"
              dataIndex="address"
            />
            <Table.Column
              title="Category"
              dataIndex="category"
            />
          </Table>
        </div>
        <div className="text-container">
          <h2>Frequently asked questions</h2>
          <div className="faq">
            <h3>How can I archive facilities?</h3>
            <p>
              Archive facilities that are no longer in use or fall outside the scope of the
              assessment by selecting the archive box icon next to the facility.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
